import { useEffect, useState } from "react";
import api from "@/lib/api";

// Cache en memoria por fecha (YYYY-MM-DD) para evitar llamadas repetidas.
const _cache = new Map();

export function fetchPeriodo(date) {
  if (!date) return Promise.resolve(null);
  const key = String(date).slice(0, 10);
  if (_cache.has(key)) return _cache.get(key);
  const promise = api
    .get(`/calendar/period-for-date?date=${key}`)
    .then((r) => r.data?.period || null)
    .catch(() => null);
  _cache.set(key, promise);
  return promise;
}

export function perLabel(p) {
  return p ? `PER${String(p.number).padStart(2, "0")}` : null;
}

export function usePeriodo(date) {
  const [per, setPer] = useState(null);
  useEffect(() => {
    let alive = true;
    if (!date) { setPer(null); return; }
    fetchPeriodo(date).then((p) => { if (alive) setPer(p); });
    return () => { alive = false; };
  }, [date]);
  return per;
}
